import {autoserialize} from 'cerialize';

export default class Package {

    @autoserialize public id: number;
    @autoserialize public name: string;
    @autoserialize public order_index: number;

    constructor(id: number,
                name: string,
                order_index: number) {

        this.id = id;
        this.name = name;
        this.order_index = order_index;
    }
}
